module.exports = __webpack_public_path__ + "img/vip5.3ca1d05c.png";